import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { useValueRef } from '@cian/react-utils';
import { useDropdownController, useFocusOptionController } from '../../../internal/hooks/controllers';
export function useSelectDesktopController(props) {
  var _useDropdownControlle = useDropdownController(props),
    open = _useDropdownControlle.open,
    dropdownActions = _useDropdownControlle.actions;
  var _useFocusOptionContro = useFocusOptionController({
      length: props.options.length
    }),
    focusedIndex = _useFocusOptionContro.focusedIndex,
    focusOptionActions = _useFocusOptionContro.actions;
  var stateRef = useValueRef({
    props: props,
    open: open,
    focusedIndex: focusedIndex
  });
  React.useEffect(function () {
    var _stateRef$current$pro = stateRef.current.props,
      options = _stateRef$current$pro.options,
      value = _stateRef$current$pro.value;
    if (!open) {
      var selectedIndex = options.findIndex(function (option) {
        return value === option.value;
      });
      focusOptionActions.setFocusedIndex(Math.max(selectedIndex, 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  var selectOption = function selectOption(index) {
    var props = stateRef.current.props;
    var option = props.options[index];
    if (!option) {
      return;
    }
    var optionValue = option.value;
    var prevValue = props.value;
    if (optionValue !== prevValue) {
      props.onChange(optionValue);
    }
  };
  var selectFocusedOption = function selectFocusedOption() {
    return selectOption(stateRef.current.focusedIndex);
  };
  var actions = _objectSpread(_objectSpread(_objectSpread({}, dropdownActions), focusOptionActions), {}, {
    selectOption: selectOption,
    selectFocusedOption: selectFocusedOption
  });
  return {
    open: open,
    focusedIndex: focusedIndex,
    actions: actions
  };
}